<template xmlns:el-col='http://www.w3.org/1999/html'>
  <div>
    <!--    提报内容-->
    <div>
      <div class='plc'>
        <div class='theme-border'>
          <div class='plc-title'>
            <PlcLogo class='plc_logo' :logo-setting='info?.logoSetting' v-if='info?.logoSetting' />
            <div class='title'>
              <span> {{ info.title }}</span>
              <div class='tag' v-if='info.sub_title'>
                <span class='sub_title'>{{ info.sub_title || '' }}</span>
              </div>
            </div>
            <div>
              <el-tooltip content='修改刊例基本信息' placement='left' effect='light'>
                <el-button type='text' icon='el-icon-edit' @click='editBtn'
                           v-if="userPermissions.indexOf('plc_edit')>-1">修改
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div class='notice'>
            <div>
              <span class='notice-title' title='notice'>合作须知：</span>
            </div>
            <div class='info_box' v-html='info.notice'></div>
          </div>
        </div>

        <!--          筛选条件-->
        <div :class="['row-opt',fixHeader?'fixed-header':'',isCollapse?'fold':'unfold']">
          <div class='table-search'>
            <el-form size='mini' :inline='true' :model='searchCondition'>
              <el-form-item>
                <el-button type='primary' icon='el-icon-plus'
                           v-if="userPermissions.indexOf('plc_adjust')>-1"
                           @click='addAPlcDetail'>
                  刊例提报
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-radio-group v-model='tabActive'>
                  <el-radio-button label='status' value='status'
                                   v-if="userPermissions.indexOf('plc_save_quote')>-1">
                    待定价
                  </el-radio-button>
                  <el-radio-button label='apply_status' value='apply_status'
                                   v-if="userPermissions.indexOf('plc_save_quote')>-1">
                    改价申请
                  </el-radio-button>
                  <el-radio-button label='my' value='my'>我的</el-radio-button>
                  <el-radio-button label='all' value='all'>全部</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label=''>
                <artist-search :name.sync='searchCondition.nickname' @handleSelect='chooseArtist'
                               @clicked='searchForm' />
              </el-form-item>
              <el-form-item>
                <el-button type='primary' icon='el-icon-search' @click='searchForm'>搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-tooltip class='item' effect='dark' content='优先使用刊例定制配置，若无，则使用该平台的全局配置'
                            placement='top-start'>
                  <el-button type='text' @click='loadSetting' :loading='loading' icon='el-icon-bangzhu'></el-button>
                </el-tooltip>

              </el-form-item>
              <el-form-item style='float: right;'>
                <el-link icon='el-icon-s-grid' type='primary'
                         @click="$router.push({ name: 'plc_tpl', params: { id: id } })"
                         v-if="userPermissions.indexOf('platform_setting')>-1">
                  模板
                </el-link>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class='plc-items'
             v-loading='loadingStatus'
             element-loading-text='刊例提报数据加载中……'
             element-loading-spinner='el-icon-loading'>
          <el-tabs v-model='activeName' @tab-click='handleClick'>
            <el-tab-pane :label='`提报记录(${pagingData.total})`' name='first'>
              <PlcRecord :setting='setting' :table-data='dataList' @editVal='editVal' @surePrice='surePrice'
                         @editPrice='editPrice'
                         @editAPlcDetail='editAPlcDetail' @delPlcItem='delPlcItem' :show-edit-btn='true'></PlcRecord>

            </el-tab-pane>
            <el-tab-pane label='提报记录-Excel预览' name='second'>
              <PlcExcelTable :setting='setting' :table-data='dataList' />
            </el-tab-pane>
          </el-tabs>


          <div>
            <m-pagination :total.sync='pagingData.total' :page.sync='pagingData.current_page'
                          :limit.sync='pagingData.page_size' @pagination='getPageList'></m-pagination>
          </div>
        </div>
        <div class='default-toolbar' style='display: none'>
          <el-link type='primary' @click='showSetting=!showSetting'>{{ showSetting ? '隐藏' : '显示' }}配置 <span
            :class='[showSetting?"el-icon-arrow-up":"el-icon-arrow-down"]'></span></el-link>
        </div>
        <div v-if='showSetting'>
          <JsonDisplay v-model='setting'
                       title='刊例配置'
                       :show-copy='true'
                       :show-format='true'
                       :show-char-count='true'
                       :bordered='false'
                       copy-text='复制'></JsonDisplay>
        </div>
      </div>
    </div>

    <!--修改：基础信息-->
    <el-dialog title='修改基本信息' width='880px' :visible.sync='dialogData.visible' :modal='true' append-to-body>
      <BaseEdit ref='refBaseEdit' @saved='dialogClose' />
    </el-dialog>

    <!--定价：商业化营销中心终价-->
    <el-dialog :title='dialogQuoteData.title'
               :visible.sync='dialogQuoteData.visible'
               direction='rtl'
               width='clamp(980px, 98%, 1280px)'>
      <RealQuoteEdit :platform-type='setting.type' ref='refRealQuoteEdit' :id='formData.id' @saved='savedQuote' />
    </el-dialog>

    <!--    数据录入（添加）-抽屉-->
    <!--      刊例提报-->
    <AdjustCreateEdit
      ref='refCreateEdit'
      :key='`AdjustCreateEdit_${editFormData.id||"0"}`'
      :plc-info='info'
      @saved='refreshList'
      @deleted='refreshList'
      @updated='refreshCurrentRow'
      @jumpToItem='jumpToPlcItem'
      style='height: 80vh' />

    <!--    改价申请-->
    <EditPriceApply ref='refEditPriceApply'></EditPriceApply>

  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ModalDialog from '@/components/ModalDialog'
import BaseEdit from '@/pages/plc/journal/BaseEdit'
import RealQuoteEdit from './RealQuoteEdit'
import { mapGetters } from 'vuex'
import ExportLink from '@/components/export/ExportLink'
import ArtistSearch from '@/components/artist/ArtistSearch'
import AdjustCreateEdit from './AdjustCreate'
import ExportBtn from '@/components/export/ExportBtn'
import { html2json } from 'html2json'
import MlPageTable from '@/components/common/MlPageTable'
import { scrollTo } from '@/utils/scroll-to'
import PlcLogo from '@/pages/plc/detail/item/PlcLogo'
import PlcExcelTable from '@/pages/plc/detail/item/PlcExcelTable'
import { getPlcTpl } from '@/api/plc'
import PlcRecord from '@/pages/plc/detail/item/PlcRecords.vue'
import EditPriceApply from '@/pages/plc/detail/item/EditPriceApply.vue'
import JsonDisplay from '@/components/display/JsonDisplay.vue'

const { deepClone } = require('@/utils')
export default {
  name: 'PlcItemPanel',
  computed: {
    ...mapGetters(['isCollapse', 'userPermissions', 'userInfo']),
    isShowAll() {
      //我的，定价，改价申请
      return ['status', 'apply_status', 'my'].indexOf(this.tabActive) > -1
    }
  },
  components: {
    JsonDisplay,
    EditPriceApply,
    PlcRecord,
    PlcExcelTable,
    PlcLogo,
    MlPageTable,
    ExportBtn,
    ArtistSearch,
    RealQuoteEdit,
    BaseEdit,
    ModalDialog,
    ExportLink,
    PageHeaderLayout,
    AdjustCreateEdit
  },
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      top: 100,
      activeName: 'first',
      loading: false,
      fixHeader: false,
      searchCondition: {},
      tabActive: 'all',
      // id: null,
      info: {
        'id': null,
        'pm_id': 0,
        'org_name': '',
        'year': '',
        'month': '',
        'title': '',
        'sheet_title': '',
        'validity_date': '',
        'expiry_date': '',
        'platform_code': '',
        'deadline': '',
        'same_notice': 0,
        'notice': '',
        'notice_rich': '',
        'order': 1,
        'created_at': '',
        'updated_at': '',
        'logo_setting': {
          'cellCol': 'F',
          'cellRow': '1',
          'offsetX': '-80',
          'offsetY': '8',
          'width': '120',
          'height': '50',
          'logo_url': 'https://tisu-prod.oss-cn-hangzhou.aliyuncs.com/pd-test/20260509/T20260509181925_23269.png'
        }
      },
      needTip: true,
      dataList: [],
      processBarNumber: 0,
      loadingStatus: false,
      orderSort: { tag: 'desc', fans_total: 'desc', id: 'desc' },//默认排序规则
      offset: 0,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 10,
        current_page: 1
        // offset: 0,
      },
      dialogData: {
        visible: false,
        title: '刊例基础资料编辑',
        width: '1280px',
        loading: true,
        modal: false,
        hide_footer: true
      },
      dialogPlcData: {
        visible: false,
        title: '刊例提报信息编辑',
        width: '1300px',
        loading: true,
        modal: false,
        hide_footer: false
      },
      formData: {},
      formItemData: { id: null, base_case: null, intro: null, bs_case_rich: null },
      editField: null,//当前编辑的字段
      editRowIndex: null,//当前修改的行号
      dialogQuoteData: {
        visible: false,
        title: '商业化营销中心终价',
        width: '80%',
        loading: true,
        modal: false,
        hide_footer: true
      },
      // quoteMap: {},
      tagMap: {
        'new': 'NEW',
        'benefit': '惠',
        'recommend': '荐'
      },
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '刊例录入',
        width_height: '1200px',
        show_footer: false,
        // mask: false,
        close_name: '关 闭'
        // confirm_name: '打 印',
      },
      editFormData: {},
      //当前刊例对应的设置
      setting: {},
      showSetting: false
    }
  },
  watch: {
    tabActive(val) {
      switch (val) {
        case 'status':
          this.searchCondition.status = 1
          this.searchCondition.apply_status = null

          break
        case 'apply_status':
          this.searchCondition.user_id = null
          this.searchCondition.status = null
          this.searchCondition.apply_status = 2
          break
        case 'all':
          this.searchCondition.user_id = null
          this.searchCondition.status = null
          this.searchCondition.apply_status = null
          break
        case 'my':
          this.searchCondition.user_id = this.userInfo.id
          this.searchCondition.status = null
          this.searchCondition.apply_status = null

          break
        default:

          break
      }
      this.getPageList()
    }
  },
  methods: {
    jumpToPlcItem(id) {
      this.$router.push({
        name: 'plc_item', params: { id: id }
      })
    },
    async loadSetting(platform_code) {
      if (this.id) {
        // 当前刊例配置
        this.loading = true
        const { setting } = await getPlcTpl(this.id)
        if (setting) {
          this.setting = setting || {}
        } else {
          // 全局配置
          const { info } = await this.$api.getPlatformSettingInfoByPlatformCode(platform_code)
          this.setting = info || {}
        }

        setTimeout(() => {
          this.loading = false
        }, 100)
      }
    },
    //编辑器
    handleTinymceInput(val) {
      this.formItemData.bs_case = val
    },
    addAPlcDetail() {
      this.$nextTick(() => {
        this.$refs['refCreateEdit'].add(this.info)
      })
    },
    editAPlcDetail(row, index, mod) {
      this.$nextTick(() => {
        this.$refs['refCreateEdit'].edit(this.info, row, mod)
      })
      this.editRowIndex = index
    },
    //改价
    editPrice(row, index) {
      this.$nextTick(() => {
        // this.$refs['refCreateEdit'].edit(this.info, row, mod)
        this.$refs['refEditPriceApply'].edit(row, this.setting)
      })
      this.editRowIndex = index
    },
    refreshCurrentRow() {
      this.drawerData.visible = false
      this.drawerData.loading = true
      //刷新当前编辑
      this.getItemInfo(this.editRowIndex)//更新数据
    },

    refreshList() {
      this.drawerData.visible = false
      this.drawerData.loading = true
      //添加新记录后，刷新列表
      this.getPageList()
    },
    async getInfo() {
      const { info } = await this.$api.getPublicationInfo(this.id)
      if (info && info.platform_code)
        await this.loadSetting(info.platform_code)

      this.$nextTick(() => {
        this.info = info
        if (!this.info.notice && this.needTip) {
          this.editBtn()
          this.needTip = false// 标记不需要载提示
        }
        scrollTo(0, 200)
      })
    },
    editBtn() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.$nextTick(() => {
        if (this.$refs['refBaseEdit'])
          this.$refs['refBaseEdit'].show(this.id)
      })

    },
    // 处理模态框，确定事件
    handleConfirm() {
      this.dialogData.loading = false
      this.dialogData.visible = false
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.loading = false
      this.dialogData.visible = false
      setTimeout(() => {
        this.getInfo()
      }, 100)
    },
    // 搜索
    searchForm() {
      // this.offset = 0
      this.pagingData.current_page = 1

      this.getPageList()

    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = { pid: this.id }

      if (this.searchCondition.artist_id) {
        condition.artist_id = this.searchCondition.artist_id
      }
      if (this.searchCondition.user_id) {
        condition.user_id = this.searchCondition.user_id
      }
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status
      }
      if (this.searchCondition.apply_status) {
        condition.apply_status = this.searchCondition.apply_status
      }

      return condition
    },
    async getPageList() {
      this.loadingStatus = true
      const pagingInfo = { page_size: this.pagingData.page_size, current_page: this.pagingData.current_page }
      const searchCondition = this.handleSearchCondition()
      // Object.assign(searchCondition, pagingInfo)
      Object.assign(searchCondition, pagingInfo, { order: this.orderSort })
      this.dataList = []
      const { list, pages } = await this.$api.getPublicationItemList(searchCondition)
      this.$nextTick(() => {
        this.dataList = list
      })
      this.pagingData.total = pages.total
      this.pagingData.current_page = pages.current_page
      this.pagingData.page_size = pages.page_size
      this.offset = pages.offset
      this.loadingStatus = false
    },
    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getPageList()
    },
    surePrice(row, index) {
      this.formData = row
      this.dialogQuoteData.loading = false
      this.dialogQuoteData.visible = true
      this.dialogQuoteData.title = `商业化营销中心终价【KOL：${row.nickname || '--'} (${row.year}年${row.month}月)】`
      this.$nextTick(() => {
        this.$refs['refRealQuoteEdit'].init(row)
      })
      this.editRowIndex = index
    },
    editRow(row, index, mod) {
      this.formData = row
      this.dialogQuoteData.loading = false
      this.dialogQuoteData.visible = true
      this.dialogQuoteData.title = `商业化营销中心终价【KOL：${row.nickname || '--'} (${row.year}年${row.month}月)】`
      this.$nextTick(() => {
        this.$refs['refRealQuoteEdit'].init(row, mod)
      })
      this.editRowIndex = index
    },
    async savedQuote(real_quote) {
      this.dialogQuoteData.loading = false
      this.dialogQuoteData.visible = false

      if (real_quote) {
        if (this.dataList[this.editRowIndex]) {
          this.dataList[this.editRowIndex]['real_quote'] = deepClone(real_quote)
          this.dataList[this.editRowIndex]['status'] = 2
          // await this.getItemInfo(this.editRowIndex)//更新数据
          await this.getPageList()
        }
      }
    },

    async delRow(id) {
      this.$confirm(`确定删除?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        //删除刊例（要求刊例明细已全部删除）
        const info = await this.$api.deletePublicationInfo(id)
        if (info === 'ok') {
          await this.$alert('删除成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              if (action === 'confirm') {
                this.backParentPage()
                // window.opener.location.reload(true);
                // window.close()
              }
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    async fixRows() {
      //修复案例
      this.dataList.forEach((item) => {
        this.processBarNumber++
        item.bs_case_rich = html2json(item.bs_case)
        const data = {
          id: item.id,
          bs_case_rich: item.bs_case_rich
        }
        const id = this.$api.savePlcItem(data)
        if (id) {
          // console.log(`ID:${data.id}(${this.processBarNumber}/${this.dataList.length})`)
        }
      })

    },
    backParentPage() {
      this.$router.go(-1)
      // this.$router.push({ name: 'plc_list', params: { year: this.info.year, month: this.info.month } })
    },

    async selectArtist(selectInfo) {

      this.searchCondition.artist_id = selectInfo.artist_id
      // this.searchCondition.dept_id = selectInfo.group_id
      this.searchForm()
    },

    //修改刊例提报信息
    editVal(row, field, index) {
      this.formItemData = { id: row.id }
      this.$set(this.formItemData, field, row[field] || '')

      this.editRowIndex = index
      this.editField = field

      this.dialogPlcData.visible = true
      this.dialogPlcData.loading = false
    },
    dialogPlcClose() {
      this.dialogPlcData.loading = false
      this.dialogPlcData.visible = false
    },
    async handlePlcConfirm() {

      const data = {
        id: this.formItemData.id
      }
      // data[this.editField] = this.formItemData[this.editField]

      data[this.editField] = this.formItemData[this.editField]
      data.bs_case_rich = html2json(this.formItemData[this.editField])
      const id = await this.$api.savePlcItem(data)
      if (id) {
        this.msgSuccess('修改成功')
        this.dataList[this.editRowIndex][this.editField] = this.formItemData[this.editField]
        this.dialogPlcData.loading = false
        this.dialogPlcData.visible = false
        await this.getItemInfo(this.editRowIndex)//更新数据
      }
    },

    delPlcItem(row, index) {
      this.$confirm(`确定删除（KOL：${row.nickname}）刊例吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = await this.$api.deletePublicationItem(row.id)
        if (info) {
          this.$notify.success('删除成功')
          this.dataList.splice(index, 1)

        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },

    //刷新一行数据
    async getItemInfo(index) {
      const id = this.dataList[index].id
      const { info } = await this.$api.getPublicationItemInfo(id)
      this.dataList[index] = deepClone(info)
      this.$forceUpdate()
    },

    //检索红人
    async chooseArtist(item) {
      if (item) {
        // this.searchCondition.group_id = item.group_id
        // this.searchCondition.group_name = item.group_name
        this.searchCondition.artist_id = item.id
        // this.searchCondition.nickname = item.nickname
      } else {
        this.searchCondition.artist_id = null
      }
      this.searchForm()
    },
    handleClick() {
      //tab切换
    }


  },
  async mounted() {
    await this.getInfo()
    await this.getPageList()

    // setTimeout(()=>{
    //   window.onscroll = () => {
    //     let scrollTop = document.documentElement.scrollTop
    //     this.top = scrollTop
    //     this.fixHeader = scrollTop >= 120
    //     console.log('滚动顶部')
    //   }
    // },100)

  },
  activated() {
    alert('提报页面')
  }
}
</script>

<style scoped>
.notice {
  border: #f2f2f2 1px solid;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 5px;
}

.row-opt .sub-title::before {
  content: '状态及操作项';
  color: #fe346e;
  font-weight: bold;
  font-size: 14px;
}

.row-opt {
  border: #f2f2f2 1px dashed;
  border-radius: 8px;
  padding: 10px;
  margin-top: 8px;

}

.row-opt:hover {
  border: #fe346e 1px dashed;
}

/* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: 'ali_family';
  font-weight: 400;
  src: url('//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/St9qE1I7fYHN.woff2') format('woff2'), url('//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/ZrrFFWybd5kb.woff') format('woff');
  font-display: swap;
}

.plc {
  /*border: 1px solid rgba(255, 49, 118, 0.5);*/
  padding: 2px;
  clear: both;

  .plc-title {
    //clear: both;
    height: 60px;
    line-height: 60px;

    //border: 1px solid red;
    display: flex;

    .plc_logo {
      max-width: 300px;
    }

    .title {
      display: inline;
      margin-left: 10px;
      font-size: 32px;
      font-family: ali_family sans-serif;
    }

    .tag {
      font-size: 1rem;
      font-weight: 600;
      color: red;
      display: inline-block;
    }

  }
}

.title-row {
  /*display: flex;*/
  text-align: center;
}

.title {
  flex: 6;
  font-weight: 700;
  font-size: 2rem;
  /*border: 1px solid rgba(255, 49, 118, 0.5);*/
  display: inline-block;
}


.date {
  flex: 2;
  font-size: 0.9rem;
  font-weight: 600;
  color: red;
  display: inline-block;
}

.date::before {
  content: '';
  font-size: 1rem;
  font-weight: 700;
}

.notice-title {
  font-weight: 800;
  font-size: 1.2rem;
}

.plc-items {
  border: #f2f2f2 1px solid;
  border-radius: 10px;
  padding: 10px;
  margin-top: 10px;
}


.price-div {
  display: flex;
  line-height: 100%;
  flex-direction: column;
  gap: 5px;
  justify-content: flex-start;
  align-items: center;
  min-height: 100px;
  /*border: #f2f2f2 1px solid;*/
  height: 100%;
  width: 100%;
}

.edit-btn {
  flex: 1;
  line-height: 100%;
  /*margin-right: 5px;*/
  vertical-align: middle;
  text-align: center;
  /*border: #0C0C0C 1px dashed;*/
  position: relative;
  margin-top: 5px;
}

.edit-quote {
  position: relative;
  top: 45%;
  vertical-align: middle;
  text-align: center;
  line-height: 100%;
  /*border: #a41818 1px dashed;*/
}

.edit-btn-size {
  font-size: 18px;
}

.edit-box {
  //border: #f2f2f2 1px dashed;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  padding: 8px;
}

.edit-row {
  padding: 10px;
  border: 1px solid rgba(242, 242, 242, 0.8);
  margin-top: 10px;
  border-radius: 10px;
  /*background-color: rgba(242,242,242,0.5)*/
}

.fanhui-button {
  float: right;
}

.case-panel .sub-title {
  font-size: 18px;
  line-height: 24px;
  padding: 6px;
  border: #fe346e 1px dashed;
  background: rgba(254, 52, 110, 0.8);
  color: #f2f2f2;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;
}

.bs_case::before {
  content: "商务案例";
  font-size: 18px;
  line-height: 24px;
  padding: 6px;
  border: #fe346e 1px dashed;
  background: rgba(254, 52, 110, 0.8);
  color: #f2f2f2;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  transform: translateX(-30%) translateY(-30%);
}

.bs_case {

}

</style>
<style>
/**
 单元格样式调整
 */
.plc-cell {
  vertical-align: top !important;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  /*left: 160px;*/
  z-index: 9;
  transition: width 0.28s;
  background: #fefefe;
  width: 98%;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  /*opacity: 0.9;*/
  /*margin-left: 10px;*/
}

.fold {
  left: 10px !important;
}

.unfold {
  left: 160px !important;
}

.info_box {
  margin: 10px 0;
  max-height: 500px;
  min-height: 200px;
  /*border: 1px solid rgb(0 0 0 / 10%);*/
  border-radius: 5px;
  padding: 5px;
  overflow-y: scroll;
}


.tox {
  z-index: 999999 !important;
  border: 1px solid red
}

.opt {
  border: #f2f2f2 1px dashed;
  padding: 10px;
  margin-top: 10px;
}


</style>
